// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"42b4246ecf5f9e47","src_app_features_ncp_ncp_module_ts":"e955f407dba06b2a","src_app_features_cp_cp_module_ts":"695eee378fcfed87"}[chunkId] + ".js";
};